/**
 * Utility function to get the correct Supabase URL based on environment
 * This ensures we use the right database instance for dev vs production
 */

/**
 * Get the base Supabase URL from environment variables
 * @returns {string} The Supabase URL
 */
export const getSupabaseUrl = () => {
  return import.meta.env.VITE_SUPABASE_URL || "https://login.artifact.chat";
};

/**
 * Get the storage URL for the current environment
 * @returns {string} The storage URL
 */
export const getStorageUrl = () => {
  const baseUrl = getSupabaseUrl();
  return `${baseUrl}/storage/v1/object/public`;
};

/**
 * Get the default avatar URL for the current environment
 * @returns {string} The default avatar URL
 */
export const getDefaultAvatarUrl = () => {
  const storageUrl = getStorageUrl();
  return `${storageUrl}/avatars/default/ChatGPT%20Image%20Jun%2015,%202025,%2006_17_34%20PM.png`;
};

/**
 * Get a full storage URL for a given path
 * @param {string} path - The storage path (e.g., 'avatars/default/image.png')
 * @returns {string} The full storage URL
 */
export const getStorageFileUrl = (path) => {
  const storageUrl = getStorageUrl();
  return `${storageUrl}/${path}`;
};

export default {
  getSupabaseUrl,
  getStorageUrl,
  getDefaultAvatarUrl,
  getStorageFileUrl,
};
